import React from 'react';

const ProgressBar = (props)=>{
	return (
		<div className="progress mb-3">
			<div className="progress-bar" role="progressbar" style={{"width": props.percentage+"%"}} aria-valuenow={props.percentage} aria-valuemin="0" aria-valuemax="100">{props.percentage}%</div>
		</div>
	)
}

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/view/ProgressBar.js